<template lang="pug">
  #QRCode
    appHeader(
      :targetRouterName="route"
      :title="'QRcode'"
    )
    router-view.content-body-hasFooter
</template>

<script>
import appHeader from '@/components/partials/AppHeader.vue';
import appSmFooter from '@/components/partials/AppSmFooter.vue';
import { SM_ITEMS_LIST_INDEX } from '@/router/sm/items-list';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'QRCodeComponent',
  components: {
    appHeader,
    appSmFooter
  },
  data() {
    return {
      route: SM_ITEMS_LIST_INDEX
    };
  }
};
</script>
